import React from "react";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";

const HeaderMenu = ({ isSuperAdmin, selectedClientDetails }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Define menu items based on role
  const menuItems = [];

  if (isSuperAdmin && selectedClientDetails?.clientId) {
    menuItems.push({
      label: "Client Configuration",
      to: `/admin/clients/configuration/${selectedClientDetails.clientId}`,
      disabled: !selectedClientDetails.active,
      tooltip: selectedClientDetails.active ? "" : "Client is inactive"
    });
  }

  // Add more items here as needed for other roles
  // if (someOtherRoleCondition) { ... }

  if (menuItems.length === 0) {
    return null;
  }

  return (
    <div className="kt-header__topbar-item">
      <IconButton
        onClick={handleClick}
        size="medium"
        color="primary"
        sx={{
          marginRight: "10px",
          padding: "6px"
        }}
      >
        <MenuIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {menuItems.map((item, index) => (
          <Tooltip key={index} title={item.tooltip || ""} placement="left">
            <span>
              <MenuItem
                component={item.disabled ? "div" : Link}
                to={item.disabled ? undefined : item.to}
                onClick={handleClose}
                disabled={item.disabled}
              >
                {item.label}
              </MenuItem>
            </span>
          </Tooltip>
        ))}
      </Menu>
    </div>
  );
};

export default HeaderMenu;
